import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import SarasTrans from "../../../../library/notifications/SarasTrans";
import FormInput from '../../../../library/form/components/FormInput';
import FormTitle from "../../../../library/form/components/FormTitle";
import RolePrivilegeEditorRow from "./RolePrivilegeEditorRow";

const RolePrivilegeEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if(!viewData)
        return(null);

    let rowData = formObject.getFormRow("", "");

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '370px' }}
            formStyle={{ width: '743px' }} formTitle={<FormTitle formObject={formObject} value="Role Header" />}
        >
            <div>
                <div className="uiRow">
                    <span className="uiLbl"><SarasTrans value="Document Type" /></span>
                    <FormInput formObject={formObject} rowKey="" className="uiVal"
                        action={{ InputType: "ac", actionId:'refresh', paramName: "docType", acMethod: "DocumentType", actionparam:{change:"1"}  }}
                    />
                </div>
                <ul className="uiForm uiItemPopupForm">
                    <li>
                        <div className="uiRow uiSpacer10">
                            <ul style={{"columnCount":2}}>
                                {
                                    Object.values(rowData.rowValues).map((row, index) => (
                                        <RolePrivilegeEditorRow formObject={formObject} rowValueKey={row.key} viewData={row} key={index} />
                                    ))
                                }
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </FormDialog>
    )
}

export default withView(RolePrivilegeEditor, "rolePrivilege", "rolePrivilege")